import type { GameDef } from "./types";
import { blockJam } from "./blockjam/index";
import { cakeMerge } from "./cakemerge/index";
import { waterSort } from "./watersort/index";
import { pipes } from "./pipes/index";
import { bubblePop } from "./bubblepop/index";
import { sweetSwap } from "./sweetswap/index";
import { sweetMatch } from "./sweetmatch/index";

// Add a new game by importing its GameDef and pushing it here. Everything else
// (catalog, level select, progress, routing) picks it up automatically.
export const GAMES: GameDef[] = [blockJam, cakeMerge, waterSort, pipes, bubblePop, sweetSwap, sweetMatch];

export function getGame(id: string): GameDef | undefined {
  return GAMES.find((g) => g.id === id);
}
